export const SUCCESS_CONTENT_REPO_LIST = "SUCCESS_CONTENT_REPO_LIST";
export const LOADING_CONTENT_REPO_LIST = "LOADING_CONTENT_REPO_LIST";
